export const translations = {
	'Metric gauge': { no: 'Metrikk gauge' },
	'Dial': { no: 'Dial' },
	'Thresholds': { no: 'Grenser' },
	'Thresholds value': { no: 'Grenseverdi' },
};
